import React from 'react'
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

//const NuDropdown = (props) => {
const ItemRowF = ({ 
    imagePath = '',
    nombre = '',
    detalle = '',
    estado=0,
    tam = '',//220.25 KB
    progress ='',
    url='',
    handleDel= null, /* */
    urlFile ='',
    }) => {

  const navigate = useNavigate();
  //------------------------------------------------------------------------------

  //let photoBlob=null
  const delete_click=()=>{
    console.log("delete_click")
    handleDel()
  }
  //-----------------------------------------------------------------
  const btn_down_click=(e, urlFile, fileName )=>{
    e.preventDefault();
    console.log(urlFile)
    //navigate(urlFile)
    //saveAs(urlFile, "example.pdf" );
    download2(urlFile, fileName, true)
  }
  //------------------------------------------------------------
  const download2 = async (urlFile, fileName, forceDownload)=> {
    
    if(!forceDownload){
      //----si es imagen muestra en pantalla 
      const link = document.createElement("a")
      link.href = urlFile
      link.download = fileName
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      return;
    }

    //----------forzamos que descargue la imagen
    const iBlob = await fetch(urlFile)
    .then((response)=> response.arrayBuffer())
    .then((buffer)=>new Blob([buffer],{type: "image/jpg"}))

    console.log(iBlob, URL.createObjectURL(iBlob) )
    
    const link = document.createElement('a')
    link.href = URL.createObjectURL(iBlob)
    link.download= fileName;

    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }
  //-----------------------------------------------------------------
  //---- manejaremos 3 estados
  /*
  0 pendiente
  1 successfully uploaded.  // subio el archivo exitosamente //correcto
  2 Error
  */
  const get_state=( estado )=> {
    
    if ( estado===0 ) {
      return <span className= "badge badge-pill badge-warning">Pendiente</span>;
    }
    if ( estado===1 ) {
      return <span className= "badge badge-pill badge-success">Correcto</span>;
    }
    if ( estado===2 ) {
      return <span className= "badge badge-pill badge-danger">Error</span>;
    }
    return "";
  }
  //-------------------------- item_selected --------------------------------------
  return (
    <li className="nufile_list_item " style={{ height: '49px' }}>
      <div className="nufile_list_item_icon ">
        <div className="nufile_list_item_file_type image">

        </div>
      </div>
      <div className="nufile_list_item_content">
        <div className="nufile_item_name">{nombre}</div>

        <div className="nufile_item_size ">{tam}</div>
      </div>
      <div style={{ width: 70 }}>
        
      </div>
      <div className="nufile_item_info">
        <div className="nufile_item_success dxi-checkbox-marked-circle">
          <i className="fa fa-check" style={{color: "green"}}></i>
        </div>
        {/*<div className="nufile_item_success ">
          <i className="fa fa-trash"></i>
        </div>*/}
        <div className="nufile_item_hover_block">
          { estado===1 &&
            <button className="nufile_item_btn_download dxi flat_btn "
                    onClick={(e)=> btn_down_click(e,urlFile,nombre) }>
              <i className="fa fa-download"></i>
            </button>
          }
        
          <button className="nufile_item_btn_remove dxi flat_btn" title="Eliminar"
            onClick={ delete_click }
            >
            <i className="fa fa-trash"></i>
            <span></span>
          </button>

        </div>

      </div>
    </li>

   
    
  )
}
export default ItemRowF;